
<div class="text-center">
    <span class="azul2"><b>Powered by</b></span>
    <br>
    <img src="../assets/images/logo/red-pyme.png" height="50px">
</div>